const BLOG_VISITOR_STORAGE_KEY = "thrive_insurance_blog_visitor_id";
const COOKIE_PREFERENCES_KEY = "thriveCookiePreferences";

const validVisitorId = (value) =>
  typeof value === "string" && /^[a-zA-Z0-9_-]{8,128}$/.test(value);

const createVisitorId = () => {
  if (typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).slice(2, 14);
  return `insurance_${timestamp}_${random}`;
};

export const getInsuranceBlogVisitorId = () => {
  if (typeof window === "undefined") return undefined;

  try {
    const existing = window.localStorage.getItem(BLOG_VISITOR_STORAGE_KEY);
    if (validVisitorId(existing)) return existing;

    const visitorId = createVisitorId();
    window.localStorage.setItem(BLOG_VISITOR_STORAGE_KEY, visitorId);
    return visitorId;
  } catch {
    // Analytics must never prevent an article from loading when storage is unavailable.
    return createVisitorId();
  }
};

export const hasInsuranceBlogAnalyticsConsent = () => {
  if (typeof document === "undefined") return false;

  const preferencesCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE_PREFERENCES_KEY}=`));
  if (!preferencesCookie) return false;

  try {
    const preferences = JSON.parse(
      decodeURIComponent(preferencesCookie.slice(preferencesCookie.indexOf("=") + 1))
    );
    return preferences?.analytics === true;
  } catch {
    return false;
  }
};

export { BLOG_VISITOR_STORAGE_KEY, COOKIE_PREFERENCES_KEY };
